import morphdom from 'morphdom';
import { deduplicatedFetch } from 'utils/deduplicate-fetch';

class AjaxContentLoaderBehaviour {
  static id = 'ajax-content-loader';

  constructor(node) {
    this.node = node;
    this.currentUrl = window.location.href;

    this.originalTransition = this.node.style.transition;

    window.addEventListener('gec:pushstate', this.handleReload);
    window.addEventListener('popstate', this.handleReload);
  }

  handleReload = async () => {
    const newUrl = window.location.href;

    if (newUrl === this.currentUrl) {
      return;
    }

    this.currentUrl = newUrl;
    await this.loadContent(newUrl);
  };

  loadContent = async (url) => {
    this.node.style.transition = 'opacity 200ms ease';
    this.node.style.opacity = '0.4';

    try {
      const response = await deduplicatedFetch(url, {
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
      });

      if (!response.ok) {
        throw new Error(`Failed to load content: ${response.status}`);
      }

      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      const selector = this.node.dataset.ajaxSelector || `.${this.node.className.split(' ')[0]}`;
      const newContent = doc.querySelector(selector);

      if (newContent) {
        morphdom(this.node, newContent, {
          getNodeKey: (node) => {
            return node.dataset ? node.dataset.key : node.id;
          },
        });
      }

      this.node.style.opacity = '1';
    } catch (error) {
      console.error('Error loading AJAX content:', error);
      this.node.style.opacity = '1';
      window.location.href = url;
    }
  };
}

export default AjaxContentLoaderBehaviour;
